import PropTypes from 'prop-types';
import cx from 'classnames';
import { useSelector } from 'react-redux';
import styles from './ProductTitle.module.scss';
import { getPartName } from '@app/utils/commonUtils';

const ProductTitle = ({ productId }) => {
  const storePartName = useSelector(s => s.products.byId?.[productId]?.name);
  const partNumber = useSelector(s => s.products.byId?.[productId]?.partNumber);
  const partName = storePartName?.includes(partNumber)
    ? storePartName
    : getPartName(partNumber, storePartName);

  return (
    <h1 className={cx('h1 display-1 mb-3', styles['product__title'])}>
      {partName}
    </h1>
  );
};

ProductTitle.propTypes = {
  productId: PropTypes.string.isRequired
};

export default ProductTitle;
